import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./ABMListProveedorCompany.module.css";
import DownloadButtonCompany from "../DownloadButtonCompany/DownloadButtonCompany";
import EditABMCompany from "../EditABMCompany/EditABMCompany";
import DownButtonCompany from "../DownButtonCompany/DownButtonCompany";
import CreateABMCompany from "../CreateABMCompany/CreateABMCompany";
import PrintButtonCompany from "../PrintButtonCompany/PrintButtonCompany";
import { TiDelete } from "react-icons/ti";
import { AiFillCheckCircle } from "react-icons/ai";

const AMBListProveedorCompany = ({
  data,
  displayList,
  setTypeDocument,
  setFileId,
  reloadChildData,
}) => {
  const [aMB, setAMB] = useState([]);
  const [documentDeletedId, setDocumentDeletedId] = useState(null);

  useEffect(() => {
    const userId = data.id;
    const apiUrl = `${process.env.REACT_APP_ABM_OF_DOCUMENT_COMPANY_GET_ALL}?userId=${userId}`;

    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrl);
        if (response.status === 204) {
          setAMB([]);
        } else {
          setAMB(response.data);
        }
      } catch (error) {}
    };

    fetchData();
  }, [data, reloadChildData, documentDeletedId]);

  const combinedValues = [
    {
      variable: "Constancia de monotributo",
    },
    {
      variable: "DNI",
    },
    {
      variable: "DJ PEP AUTORIDADES (134/2018)",
    },
    {
      variable: "ESTATUTO - REFORMA ESTATUTARIA",
    },
    {
      variable: "ULTIMO BALANCE CERTIFICADO",
    },
    {
      variable: "DJ DE PERSONAS JURIDICAS",
    },
    {
      variable: "Otra documentación",
    },
  ].map((item) => {
    // Resto del mapeo si no es un 404
    const matchingDocument = aMB.find(
      (doc) => doc.typeDocument === item.variable
    );

    if (matchingDocument) {
      return {
        id: matchingDocument.id,
        file: "Yes",
        estado: <AiFillCheckCircle style={{ color: "green" }} />,
        variable: item.variable,
        valorObtenido: matchingDocument.description,
        riesgoObtenido: `${
          matchingDocument.expiresAt === "1"
            ? "1 Mes"
            : matchingDocument.expiresAt + " Meses"
        }`,
      };
    } else {
      return {
        estado: <TiDelete style={{ color: "red" }} />,
        file: "No",
        variable: item.variable,
        valorObtenido: "-",
        riesgoObtenido: "-",
      };
    }
  });

  const OpenForm = (viewOrNot) => {
    displayList(viewOrNot);
  };

  return (
    <div className={styles.bodyMDR}>
      <>
        <table className={styles.tableMDR}>
          <thead>
            <tr>
              <th>Estado</th>
              <th>Tipo de archivo</th>
              <th>Descripcion</th>
              <th>Fecha de vencimiento</th>
              <th>Alta</th>
              <th>Baja</th>
              <th>Modificacion</th>
              <th>Descargar</th>
              <th>Imprimir</th>
            </tr>
          </thead>
          <tbody>
            {combinedValues.map((item, index) => (
              <tr key={index}>
                <td>{item.estado}</td>
                <td>{item.variable}</td>
                <td>{item.valorObtenido}</td>
                <td className={styles.numberSquareMDR}>
                  <div className={styles.numberContainerMDR}>
                    <p>{item.riesgoObtenido}</p>
                  </div>
                </td>
                <td>
                  {item.file === "No" ? (
                    <CreateABMCompany
                      setTypeDocument={setTypeDocument}
                      typeDocument={item.variable}
                      OpenForm={OpenForm}
                    />
                  ) : (
                    <div></div>
                  )}
                </td>
                <td>
                  {item.file === "Yes" ? (
                    <DownButtonCompany
                      id={item.id}
                      onDocumentDeleted={setDocumentDeletedId}
                    />
                  ) : (
                    <div></div>
                  )}
                </td>
                <td>
                  {item.file === "Yes" ? (
                    <EditABMCompany
                      setTypeDocument={setTypeDocument}
                      typeDocument={item.variable}
                      setFileId={setFileId}
                      id={item.id}
                      OpenForm={OpenForm}
                    />
                  ) : (
                    <div></div>
                  )}
                </td>
                <td>
                  {item.file === "Yes" ? (
                    <DownloadButtonCompany
                      id={item.id}
                      typeDocument={item.variable}
                    />
                  ) : (
                    <div></div>
                  )}
                </td>
                <td>
                  {item.file === "Yes" ? (
                    <PrintButtonCompany id={item.id} />
                  ) : (
                    <div></div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    </div>
  );
};

export default AMBListProveedorCompany;
